<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.root"
  >
    <div :style="style.container">
      <div :style="style.topText">
        <slot name="top" />
      </div>
      <img
        v-if="src !== null"
        :src="src"
        :style="style.image"
      />
      <div :style="style.bottomText">
        <slot name="bottom" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseDataPlaceholder',
    inheritAttrs: false,
    props: {
      src: {
        type: [Object, String],
        required: false,
        default: null,
      },
      styleConfig: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        style: {
          bottomText: {
            overflowWrap: 'break-word',
            textAlign: 'center',
            wordWrap: 'break-word',
          },
          container: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'center',
            width: '100%',
          },
          image: {
            height: '100%',
            objectFit: 'cover',
            width: '100%',
          },
          root: {},
          topText: {
            overflowWrap: 'break-word',
            textAlign: 'center',
            wordWrap: 'break-word',
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.bottomText,
        this.styleConfig.bottomText,
      );
      Object.assign(
        this.style.container,
        this.styleConfig.container,
      );
      Object.assign(
        this.style.image,
        this.styleConfig.image,
      );
      Object.assign(
        this.style.topText,
        this.styleConfig.topText,
      );
    },
  };
</script>
